module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "profile"
    }
  }, [(!_vm.token) ? _c('div', {
    staticClass: "half-side"
  }) : _vm._e(), _vm._v(" "), (!_vm.token) ? [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-md-offset-1"
  }, [_c('div', {
    staticClass: "login"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Sign in")]), _vm._v(" "), (_vm.login.topError) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.login.topError))])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    class: [_vm.login.email ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.email),
      expression: "login.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.login.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.login, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.login.formError && typeof _vm.login.formError.email !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.login.formError.email))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: [_vm.login.password ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.password),
      expression: "login.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.login.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.login, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.login.formError && typeof _vm.login.formError.password !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.login.formError.password))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-button', {
    staticClass: "pull-left",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.signin($event)
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-link pull-right",
    attrs: {
      "to": "/restore-password",
      "tag": "button"
    }
  }, [_vm._v("\n                  Forgot Password?\n                ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "register"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Register")]), _vm._v(" "), (_vm.registration.topError) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.registration.topError))])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: [_vm.registration.firstName ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registration.firstName),
      expression: "registration.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.registration.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registration, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.registration.formError && typeof _vm.registration.formError.firstName !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.registration.formError.firstName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: [_vm.registration.lastName ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registration.lastName),
      expression: "registration.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.registration.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registration, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.registration.formError && typeof _vm.registration.formError.lastName !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.registration.formError.lastName))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    class: [_vm.registration.email ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registration.email),
      expression: "registration.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.registration.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registration, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.registration.formError && typeof _vm.registration.formError.email !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.registration.formError.email))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: [_vm.registration.password ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registration.password),
      expression: "registration.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.registration.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registration, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.registration.formError && typeof _vm.registration.formError.password !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.registration.formError.password))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: [_vm.registration.password_confirmation ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Confirm Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registration.password_confirmation),
      expression: "registration.password_confirmation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Confirm Password"
    },
    domProps: {
      "value": (_vm.registration.password_confirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registration, "password_confirmation", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.registration.formError && typeof _vm.registration.formError.password_confirmation !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.registration.formError.password_confirmation))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group not-hide-label"
  }, [_c('b-form-checkbox', {
    class: [_vm.registration.termsAndCondition ? 'is-checked' : ''],
    attrs: {
      "id": "termsAndConditions",
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: (_vm.registration.termsAndCondition),
      callback: function($$v) {
        _vm.$set(_vm.registration, "termsAndCondition", $$v)
      },
      expression: "registration.termsAndCondition"
    }
  }, [_vm._v("\n                  I agree with "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_vm._v("Terms")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_vm._v("Privacy")]), _vm._v("\n                  of Kungfood.co.uk\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.register($event)
      }
    }
  }, [_vm._v("Register")])], 1)])])])])])] : _vm._e(), _vm._v(" "), (_vm.token) ? [_c('div', {
    staticClass: "my-profile"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('h2', [_vm._v(_vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name))]), _vm._v(" "), _c('h5', [_vm._v("Kungfood member since " + _vm._s(_vm.user.created_at))])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('b-btn', {
    staticClass: "logout-btn",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("Logout")])], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('b-tabs', [_c('b-tab', {
    attrs: {
      "title": "My Details",
      "active": ""
    }
  }, [_c('br'), _vm._v(" "), _c('MyDetails')], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "My Orders"
    }
  }, [_c('br'), _vm._v(" "), _c('MyOrders')], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "My Payment Sources"
    }
  }, [_c('br'), _vm._v(" "), _c('MyPaymentSources')], 1)], 1)], 1)])])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3ba8b3a7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/profile/profile.vue
// module id = 547
// module chunks = 1